








import { Component, Prop, Vue } from 'vue-property-decorator';
import { Step } from './Step';
import CartPageStep from './CartPageStep.vue';

@Component({ components: { CartPageStep } })
export default class CartPageStepper extends Vue {
  @Prop({ required: true })
  public step: number;
  @Prop({ required: false, default: '/my/shopping-cart' })
  public link: string;
  public steps = Step;
}
